<template>
	<div style="height: 100%;">
		<page v-if="$route.path === '/visitor/activity'" class="listClass activity">
			<ZuiHeader />
			<PageNavigater></PageNavigater>
			<!-- 其余用这的样式 -->
			<div class="contain">
				<div class="content">
					<div class="bg">
						<!-- tab做个参数可有可无 ，超过4个，class加个more -->

						<div class="tab">
							<div class="tab-item" :class="{ active: activeTabIndex === index }"
								v-for="(item, index) in tabList" :key="index" @click="tab(index)">{{ item.name }}
							</div>
						</div>
						<cms-article-list :pid="articlePid" :limit="8" :page="currentPage" unshift class="data-list"
							@loaded="articleLoaded">
							<template slot-scope="{ list }">

								<!--普通文章列表-->
								<template>
									<a class="data-item" :class="isIE ? 'classie' : ''" v-for="item in list" :key="item.id" target="_blank" :href="'/new/visitor/activity/info?id=' + item.id">
										<div class="calc">
											<span>{{ item | monthDay}}</span>
											<div class="year">{{ item | year }}</div>
										</div>
										<div class="line"></div>
										<div class="rightContent">
											<div class="artile-title">
												{{ item.title }}
											</div>
											<div class="artile-content">
												{{ item.intro }}
											</div>
											<a class="artile-detail" target="_blank" :href="'/new/visitor/activity/info?id=' + item.id">查看详情</a>
										</div>
										<div class="img">
											<cms-image :src="item.cover"></cms-image>
										</div>
									</a>
									<div class="no-content" v-if="list.length === 0">暂无内容</div>
								</template>
							</template>
						</cms-article-list>

						<!-- 底下分页器做个参数，可有可无 -->
						<div class="page">
							<el-pagination background layout="prev, pager, next" :page-size="8" :total="total"
								@current-change="pageChange">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>

			<ZuiFooter />
		</page>
		<router-view v-else></router-view>
	</div>
</template>
<script>
	import '../less/list.css'
	import '../less/activity.css'
	import {
		getColumns
	} from "~/api/CmsApi";
	import moment from "moment";
	export default {
		data() {
			return {
				pid: 32,
				total: 0,
				currentPage: 1,
				activeTabIndex: 0,
				articlePid: null,
				tabId: '',
				tabList: [],
				defaultTabId: '',
				isIE: false
			}
		},
		mounted() {
			this.defaultTabId = this.$route.query.id;
			this.getTabs();
			localStorage.removeItem('article_pid');
			localStorage.removeItem('article_pname');
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			if (document.documentMode)
				this.isIE = true;
		},
		filters: {
			monthDay(item) {
				return item.createTime.slice(5, 10);
			},
			year(item) {
				return item.createTime.slice(0, 4);
			}
		},
		methods: {
			tab(index) {
				this.activeTabIndex = index;
				this.articlePid = this.tabList[index].id;
				this.currentPage = 1;
				this.$emit('tab-change', index);
			},
			getTabs() {
				const param = {
					page: 1,
					limit: 99,
					pid: this.pid
				};
				getColumns(param).then(res => {
					if (res.code === 0) {
						const list = res.data.records || [];
						if (this.sortBy === 'sort') {
							list.sort((a, b) => a.sort - b.sort);
						}
						this.tabList = list;

						if (this.defaultTabId) {
							const defaultTabIndex = this.tabList.findIndex(a => a.id === this.defaultTabId);
							this.activeTabIndex = defaultTabIndex === -1 ? 0 : defaultTabIndex;
							this.articlePid = this.tabList[this.activeTabIndex].id;
						} else {
							this.articlePid = this.tabList[0].id
						}
					} else {
						console.warn('栏目信息获取失败');
					}
				})
			},

			articleLoaded(list, total) {
				this.total = total;
			},
			pageChange(page) {
				this.currentPage = page;
			},
			articleClick(item) {
				this.$openNewWindow('/new/visitor/activity/info?id=' + item.id);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/visitor/activityNew.vue